import { GlobalAccessLevel } from '@/security/constants/GlobalAccessLevel';
import { DataAccess } from '@/security/types/DataAccess';

export class GlobalAccessTargetModel {
  id!: StringOrNumber;
  access!: GlobalAccessLevel;
  dataAccess?: Nullable<DataAccess>;
  hasDataAccess!: boolean;
}

export class GlobalAccessTarget extends GlobalAccessTargetModel implements GlobalAccessTargetModel {
  constructor(model: GlobalAccessTargetModel) {
    super();

    this.id = model.id;
    this.access = model.access;
    this.dataAccess = model.dataAccess;
    this.hasDataAccess = model.hasDataAccess;
  }
}
